import $ from "jquery";
import { loadPosts } from "../utils/fetch-posts";

$(function () {
  // On posts load more click

  $(".js-posts-load").on("click", function () {
    const postType = $(".js-posts-load").attr("data-post-type") ?? "post";
    loadPosts({
      page: $(".js-posts").attr("data-page"),
      postType,
    });
  });

  // Update posts on category change
  $(".btn--cat").on("click", function () {
    $(".btn--cat").removeClass("active");
    $(this).addClass("active");

    let data = {
      page: 1,
      postType: $(".js-posts-load").attr("data-post-type") ?? "post",
      replace: true,
    };

    // Check category taxonomy from posts
    if ($(this).attr("data-category")) {
      data.category = $(this).attr("data-category");
    }

    loadPosts(data);
  });
});
